import { userConstants } from '../_constants';
import { changePassEffect, commonEffect } from '../_effects';

export const changePassActions = {
  changePass,
  clearPreviousMessage,
};

function clearPreviousMessage() {
  return (dispatch) => {
    dispatch(clearMessage());
  };
  function clearMessage() {
    return { type: userConstants.CLEAR_PWD_MESSAGE, payload: null };
  }
}

function changePass(pass) {
  return (dispatch) => {
    dispatch(request(pass));
    changePassEffect.changePassSet(pass).then(
      (result) => {
        dispatch(success(result));
        // if (result.data.statusCode === '200') {
        //   history.push('/more');
        // }
        // else {
        //   history.push('/forgot-password');
        // }
      },
      (error) => {
        console.log('action pass error', error);
        dispatch(failure(error.toString()));
      }
    );
  };

  function request(pass) {
    return { type: userConstants.CHANGEPASS_REQUEST, pass };
  }
  function success(pass) {
    return { type: userConstants.CHANGEPASS_SUCCESS, pass };
  }
  function failure(error) {
    return { type: userConstants.CHANGEPASS_FAILURE, error };
  }
}
